<template>
  <div
    :style="{
      '--font-size': `${data.fontSize}px`,
      color: isPortrait ? verticalColor : data.color,
      fontFamily: FontLoader.buildFontFamily(data.font),
      textAlign: data.align,
    }"
    :class="`${size} ${weight} media-text`"
    :dir="languageDir"
  >
    {{ data.value }}
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import useOrientation from '@/composables/useOrientation';
import { DEFAULT_FONT_OVERLAY_COLOR } from '@/js/constants';
import FontLoader from '@/js/fontLoader';
import useConfig from '@/composables/useConfig';

export default defineComponent({
  name: 'MediaHeadlineComponent',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'medium',
    },
    weight: {
      type: String,
      default: 'normal',
    },
  },

  setup(props) {
    const { isPortrait } = useOrientation();
    const { languageDir } = useConfig();

    return {
      isPortrait,
      verticalColor: props.data.vertical_color || DEFAULT_FONT_OVERLAY_COLOR,
      FontLoader,
      languageDir,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/scss/common-ui.scss";

.media-text {
  white-space: pre-wrap;
  overflow-wrap: break-word;
  overflow: hidden;
  position: relative;
  z-index: 1;
  @include font-size-responsive();

  &.normal {
    line-height: 1.4;
    margin-bottom: clamp(10px, 2.3vmin, 24px);
    padding-inline: clamp(14px, 2.3vmin, 24px);
  }

  &.bold {
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: clamp(14px, 2.3vmin, 24px);
    padding-inline: clamp(14px, 2.3vmin, 24px);
  }
}
</style>
